import React from 'react';
import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

function PageTitle({ showOnMobile = false }) {
  const location = useLocation();

  return (
    <Box sx={{ 
      display: { xs: showOnMobile ? 'flex' : 'none', md: showOnMobile ? 'none' : 'flex'}, 
      flexGrow: 1,
      padding: showOnMobile ? '24px 48px 0' : 0 
    }}>
      <Typography component="h2" variant="pageHeader">
        {location.pathname === '/dashboard' && 'Dashboard'}
        {location.pathname === '/settings' && 'Account Settings'}
        {location.pathname === '/activity' && 'Activity'}
        {(location.pathname === '/new-game' || location.pathname === '/games/:id/invite') && 'Setup'}
        {location.pathname === '/games/:id' && 'Game'}
        {location.pathname === '/find-a-game' && 'Find A Game'}
      </Typography>
    </Box>
  )
}

export default PageTitle;